import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { IIssueTypeWorkflow } from "@common/interfaces/issueTypeWorflow";
import { Topics } from "@common/interfaces/topics";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";

export interface IssueTypeWorkflowState extends EntityState<IIssueTypeWorkflow, ID> { }

@Injectable({
    providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.ISSUE_TYPE_WORKFLOWS , realtimeEntity: 'IssueTypeWorkflow'})
export class IssueTypeWorkflowStore extends EntityStore<IssueTypeWorkflowState> {
    constructor() {
        super([]);
    }
}
